import React, { useState, useEffect } from 'react';
import TradingStrategies from './TradingStrategies'
import AlertSandbox from "./AlertSandbox"
import ConfigureAlert from "./ConfigureAlert"
import StockCorelation from '../plan/StockCorrelation'
import StockResearch from '../stock/StockResearch'
import DiscretionaryAlerts from './DiscretionaryAlerts'
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import { useParams } from 'react-router-dom';


function Alerts(props) {

    let { activeTab } = useParams();

    const [tab, setTab] = useState(activeTab ? activeTab : 'summary');
    const [symbols, setSymbols] = useState([]);

    useEffect(() => {
        (async function () {
            const syms = await (await fetch(`/api/strategySymbols`)).json();
            setSymbols(syms);
        })();
    }, []);

    function shouldAllow() {
        return true;
    }

    const handleChangeTab = (event, newTab) => {
        setTab(newTab);
    };

    return (
        <div>
            {shouldAllow() ?
                <>
                    <Box sx={{ bgcolor: '#F0F0F0', border: 1, borderBottom: 0, borderColor: 'black', borderRadius: 0 }}>
                        <Tabs
                            value={tab}
                            onChange={handleChangeTab}
                            textColor="secondary"
                            indicatorColor="secondary"
                            variant="scrollable"
                            scrollButtons="auto"
                        >
                            <Tab value="summary" label="View" />
                            <Tab value="sandbox" label="Sandbox" />
                            <Tab value="discretionary" label="Discretionary" />
                            <Tab value="research" label="Research" />
                            <Tab value="correlations" label="Stock Correlations" />
                        </Tabs>
                    </Box>
                    <br></br>

                    {tab === "summary" ?
                        <>
                            <TradingStrategies planId={props.planId} mobileView={props.mobileView} role={props.role} onAlgoSelected={props.onAlgoSelected} onAlertSelected={props.onAlertSelected} />
                        </>
                        : null}
                    {tab === "discretionary" ?
                        <>
                            <DiscretionaryAlerts role={props.role} />
                        </>
                        : null}
                    {tab === "sandbox" ?
                        <>
                            <AlertSandbox mobileView={props.mobileView} role={props.role} />
                        </>
                        : null}
                    {tab === "configure" ?
                        <>
                            <ConfigureAlert mobileView={props.mobileView} onAlgoSelected={props.onAlgoSelected} role={props.role} alertId={props.alertId} planId={props.planId} />
                        </>
                        : null}
                    {tab === "correlations" ?
                        <>
                            <StockCorelation symbols={symbols} />
                        </>
                        : null}

                    {tab === "research" ?
                        <>
                            <StockResearch />
                        </>
                        : null}
                </>
                :
                <div class="empty-page" >Not allowed</div>
            }


        </div>
    );
}

export default Alerts;